/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddressResultResource
 */
export interface AddressResultResource {
    /**
     * 
     * @type {string}
     * @memberof AddressResultResource
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressResultResource
     */
    street2?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressResultResource
     */
    zipCode?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressResultResource
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressResultResource
     */
    region?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressResultResource
     */
    countryCode?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressResultResource
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressResultResource
     */
    formattedAddress?: string;
}

/**
 * Check if a given object implements the AddressResultResource interface.
 */
export function instanceOfAddressResultResource(value: object): value is AddressResultResource {
    return true;
}

export function AddressResultResourceFromJSON(json: any): AddressResultResource {
    return AddressResultResourceFromJSONTyped(json, false);
}

export function AddressResultResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddressResultResource {
    if (json == null) {
        return json;
    }
    return {
        
        'street': json['street'] == null ? undefined : json['street'],
        'street2': json['street2'] == null ? undefined : json['street2'],
        'zipCode': json['zipCode'] == null ? undefined : json['zipCode'],
        'city': json['city'] == null ? undefined : json['city'],
        'region': json['region'] == null ? undefined : json['region'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'country': json['country'] == null ? undefined : json['country'],
        'formattedAddress': json['formattedAddress'] == null ? undefined : json['formattedAddress'],
    };
}

export function AddressResultResourceToJSON(value?: AddressResultResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'street': value['street'],
        'street2': value['street2'],
        'zipCode': value['zipCode'],
        'city': value['city'],
        'region': value['region'],
        'countryCode': value['countryCode'],
        'country': value['country'],
        'formattedAddress': value['formattedAddress'],
    };
}

